var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3, _path9, _path10, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 165,
    viewBox: "0 0 197 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 82.5,
    r: 82,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.75 97.9375C119.417 97.9375 118.312 96.8325 118.312 95.5V64.625C118.312 62.3825 116.493 60.5625 114.25 60.5625H96.375C95.0425 60.5625 93.9375 59.4575 93.9375 58.125C93.9375 56.7925 95.0425 55.6875 96.375 55.6875H114.25C119.19 55.6875 123.188 59.685 123.188 64.625V95.5C123.188 96.8325 122.083 97.9375 120.75 97.9375Z",
    fill: "#E0635D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.5 68.6875C103.948 68.6875 103.395 68.4926 102.94 68.1351L93.19 60.0101C92.6375 59.5551 92.3125 58.8725 92.3125 58.125C92.3125 57.3775 92.6375 56.7275 93.19 56.24L102.94 48.115C103.98 47.2375 105.507 47.4001 106.385 48.4401C107.262 49.4801 107.1 51.0076 106.06 51.8851L98.5525 58.125L106.06 64.365C107.1 65.2425 107.23 66.77 106.385 67.81C105.897 68.395 105.182 68.6875 104.5 68.6875Z",
    fill: "#E0635D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.75 117.438C114.023 117.438 108.562 111.977 108.562 105.25C108.562 98.5225 114.023 93.0625 120.75 93.0625C127.477 93.0625 132.938 98.5225 132.938 105.25C132.938 111.977 127.477 117.438 120.75 117.438ZM120.75 97.9375C116.72 97.9375 113.438 101.22 113.438 105.25C113.438 109.28 116.72 112.562 120.75 112.562C124.78 112.562 128.062 109.28 128.062 105.25C128.062 101.22 124.78 97.9375 120.75 97.9375Z",
    fill: "#E0635D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.625 109.312H81.75C76.81 109.312 72.8125 105.315 72.8125 100.375V69.5C72.8125 68.1675 73.9175 67.0625 75.25 67.0625C76.5825 67.0625 77.6875 68.1675 77.6875 69.5V100.375C77.6875 102.618 79.5075 104.438 81.75 104.438H99.625C100.958 104.438 102.062 105.542 102.062 106.875C102.062 108.208 100.958 109.312 99.625 109.312Z",
    fill: "#E0635D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 117.438C90.8175 117.438 90.1025 117.145 89.615 116.56C88.7375 115.52 88.9 113.993 89.94 113.115L97.4475 106.875L89.94 100.635C88.9 99.7578 88.77 98.2303 89.615 97.1903C90.4925 96.1503 92.02 96.0202 93.06 96.8652L102.81 104.99C103.363 105.445 103.688 106.128 103.688 106.875C103.688 107.623 103.363 108.273 102.81 108.76L93.06 116.885C92.605 117.243 92.0525 117.438 91.5 117.438Z",
    fill: "#E0635D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.25 71.9375C68.5225 71.9375 63.0625 66.4775 63.0625 59.75C63.0625 53.0225 68.5225 47.5625 75.25 47.5625C81.9775 47.5625 87.4375 53.0225 87.4375 59.75C87.4375 66.4775 81.9775 71.9375 75.25 71.9375ZM75.25 52.4375C71.22 52.4375 67.9375 55.72 67.9375 59.75C67.9375 63.78 71.22 67.0625 75.25 67.0625C79.28 67.0625 82.5625 63.78 82.5625 59.75C82.5625 55.72 79.28 52.4375 75.25 52.4375Z",
    fill: "#E0635D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 144.5L9.39064 149.609L14.5 151.5L9.39064 153.391L7.5 158.5L5.60936 153.391L0.5 151.5L5.60936 149.609L7.5 144.5Z",
    fill: "#E0635D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 126.5L22.1205 130.879L26.5 132.5L22.1205 134.121L20.5 138.5L18.8795 134.121L14.5 132.5L18.8795 130.879L20.5 126.5Z",
    fill: "#E0635D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 147,
    r: 2.5,
    fill: "#4DA8B7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 136,
    r: 2.5,
    fill: "#4DA8B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.5 24.5L179.391 29.6094L184.5 31.5L179.391 33.3906L177.5 38.5L175.609 33.3906L170.5 31.5L175.609 29.6094L177.5 24.5Z",
    fill: "#E0635D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.5 6.5L192.121 10.8795L196.5 12.5L192.121 14.1205L190.5 18.5L188.879 14.1205L184.5 12.5L188.879 10.8795L190.5 6.5Z",
    fill: "#E0635D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 27,
    r: 2.5,
    fill: "#4DA8B7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 16,
    r: 2.5,
    fill: "#4DA8B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.a64f8fbfa288716fa6481f27666e4d6c.svg";
export { ForwardRef as ReactComponent };